module.exports = __webpack_public_path__ + "media/images/official/voice_fukushima-1de84dbdfef1d00d51ab05c4629f9b4b.png";